import { useEffect, useState } from "react";
import { getLivingAreaDetail, searchLivingAreas } from "../../../repository/RealEstateRepository";
import { LivingAreaDetail } from "../organism";
import { DefaultPage } from "./";

const links = [
  {
    title: "Home",
    to: "/realestate"
  },
  {
    title: "LivingArea",
    to: "/realestate/livingarea"
  },
  {
    title: "Detail"
  }
];

const LivingAreaDetailPage = (props) => {
  const { livingAreaId } = props.match.params;
  const [onLoad, setOnLoad] = useState(false);
  const [detail, setDetail] = useState(null);
  const [livingAreaList, setLivingAreaList] = useState([]);
  const [nearLivingAreaList, setNearLivingAreaList] = useState([]);

  useEffect(() => {
    reload(livingAreaId);
  }, [livingAreaId]);

  const reload = (livingAreaId) => {
    setOnLoad(false);
    getLivingAreaDetail({ id: livingAreaId }, (detail) => {
      setDetail(detail);
      searchLivingAreas({ frontYardId: detail.frontYardId }, (res) => {
        setLivingAreaList(res.content);
        setTimeout(() => setOnLoad(true));
      });
    });
  };

  const onChangeMapBounds = (map) => {
    const params = {
      withBoundary: true,
      swLat: map.bounds.getSW().y,
      swLng: map.bounds.getSW().x,
      neLat: map.bounds.getNE().y,
      neLng: map.bounds.getNE().x,
      centerLat: map.center.y,
      centerLng: map.center.x
    };
    searchLivingAreas(params, (res) => setNearLivingAreaList(res.content));
  };

  return (<>
    <DefaultPage pathname={props.location.pathname} links={links}>
      {onLoad && (<>
        <LivingAreaDetail
          history={props.history}
          detail={detail}
          reload={reload}
          onChangeMapBounds={onChangeMapBounds}
          livingAreaList={livingAreaList}
          nearLivingAreaList={nearLivingAreaList} />
      </>)}
    </DefaultPage>
  </>);
};

export { LivingAreaDetailPage };
